import { render, staticRenderFns } from "./MenuTop.vue?vue&type=template&id=0371b6fe"
import script from "./MenuTop.vue?vue&type=script&lang=ts"
export * from "./MenuTop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports